import React, { useState, useEffect } from "react";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import { useNavigate } from "react-router-dom";
import { Button, Col, Form, message, Row, Steps } from "antd";
import { FormTienda } from "../components/FormTienda";
import { FormFechaHora } from "../components/FormFechaHora";
import { UseAdmin, UseUser } from "../hooks";
import { AddFetchPersonal } from "../Api/Administracion/AddFetchPersonal";
import "../theme/PrestamoPersonal.css";
import {BtnGoBack} from "../components/Buttons/BtnGoBack";
import { useDynamicAuth } from "../context/AuthProviderContext"; // Importar el hook

const contentStyle = {
  marginTop: "40px",
  marginBottom: "30px",
  textAlign: "center",
};

const succesButtonStyle = {
  color: "white",
  backgroundColor: "#4DBF6C",
  borderColor: "#4DBF6C",
  minWidth: "150px",
  borderRadius: "20px",
  minHeight: "38px",
};

const backButtonStyle = {
  margin: "0px 8px",
  minWidth: "150px",
  minHeight: "38px",
  borderColor: "#B0B0B0",
  borderRadius: "20px",
  color: "#CB0B3D",
  textDecoration: "underline",
};

export const SeleccionTienda = () => {
  const navigate = useNavigate();
  const authProvider = useDynamicAuth();
    const [current, setCurrent] = useState(0);
  const { employeeId } = UseUser();
  const { brandfiMarcaId, branchFiSucursalId, branchFiPaisId } = UseAdmin();
  const [personal, setPersonal] = useState({
    stateValue: "",
    stateText: "",
    storeValue: "",
    storeText: "",
    storeSchedule: null,
    daysValue: null,
    timeValue: null,
    workerValue: null,
    workerName: null,
  });
  const [storeForm] = Form.useForm();
  const [dateTimeForm] = Form.useForm();
  const forms = [storeForm, dateTimeForm];

  const steps = [
    {
      title: "",
      content: () => <FormTienda personal={personal} setPersonal={setPersonal} form={forms[0]} />,
    },
    {
      title: "",
      content: () => (
        <FormFechaHora personal={personal} setPersonal={setPersonal} form={forms[1]} />
      ),
    },
  ];

  const getForm = (index) => (index ? forms[index] : forms[current]);

  const saveData = async () => {
    const form = getForm();
    form.validateFields().then(() => {
      const onFailure = (error) => {
        console.log(error);
      };
      const onSuccess = () => {
        message.success("Se ha salvado correctamente!");
        navigate("/solicitudes");
      };
      // debugger;
      const data = {
        idSolicitudPais: branchFiPaisId,
        idSolicitudMarca: brandfiMarcaId,
        idSolicitudTienda: personal.storeValue,
        // TODO validar si se usa
        // "idSolicitudPrestador": 2252762,
        fechaInicialSolicitud: personal.daysValue[0],
        fechaFinalSolicitud: personal.daysValue[1],
        horaSolicitud: personal.timeValue,
        idSolicitanteUsuario: employeeId,
        idSolicitanteTienda: branchFiSucursalId,
      };
      AddFetchPersonal(data).then(onSuccess).catch(onFailure);
    });
  };

  const next = () => {
    const form = getForm();
    form.validateFields().then(() => setCurrent(current + 1));
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  return (
    <AzureAD provider={authProvider}>
      {({authenticationState}) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
              <div className="body-color-admin">
                  <div className="title-name-admin">
                      <BtnGoBack caption="Selección de Tienda" />
                  </div>


              <Row justify="center" align="top" style={{ marginTop: 30, height: 780 }}>
                <Col
                  xs={22}
                  md={22}
                  style={{
                    backgroundColor: "white",
                    borderRadius: 10,
                    minHeight: "100%",
                    height: "auto",
                  }}
                >
                  <Row justify="space-between" align="middle" className="my-3 ">
                    <Col
                      span={6}
                      offset={9}
                      style={{ backgroundColor: "white", borderRadius: 10, height: 600 }}
                    >
                      <Steps current={current} items={items} />
                      <div style={contentStyle}>{steps[current].content()}</div>
                      <div className={"info-container"}
                        style={{
                          minHeight: 124,
                          borderRadius: 20,
                          marginTop: 20,
                          paddingBottom: 10,
                        }}
                      >
                        <div style={{ padding: 20 }}>
                          <div style={{ color: "white", textAlign: "left" }}>
                            <div style={{ marginBottom: 10 }}>
                              <div style={{ fontWeight: "bold" }}>Estado:</div>
                              <div
                                style={{
                                  fontWeight: "normal",
                                  minHeight: "21px",
                                }}
                              >
                                {personal?.stateText}
                              </div>
                            </div>
                            <div style={{ marginBottom: 10 }}>
                              <div style={{ fontWeight: "bold" }}>Tienda:</div>
                              <div
                                style={{
                                  fontWeight: "normal",
                                  minHeight: "21px",
                                }}
                              >
                                {personal?.storeText}
                              </div>
                            </div>
                            {personal?.daysValue && (
                              <div style={{ marginBottom: 10 }}>
                                <div style={{ fontWeight: "bold" }}>Días seleccionados:</div>
                                <div style={{ fontWeight: "normal", minHeight: "21px" }}>
                                  {Array.isArray(personal?.daysValue)
                                    ? `${personal.daysValue[0]} al ${personal.daysValue[1]}`
                                    : ""}
                                </div>
                              </div>
                            )}
                            {personal?.timeValue && (
                              <div style={{ marginBottom: 10 }}>
                                <div style={{ fontWeight: "bold" }}>Horario seleccionado:</div>
                                <div
                                  style={{
                                    fontWeight: "normal",
                                    minHeight: "21px",
                                  }}
                                >
                                  {personal.timeValue}
                                </div>
                              </div>
                            )}
                            {personal?.workerName && (
                              <div style={{ marginBottom: 10 }}>
                                <div style={{ fontWeight: "bold" }}>Colaborador:</div>
                                <div
                                  style={{
                                    fontWeight: "normal",
                                    minHeight: "21px",
                                  }}
                                >
                                  {personal.workerName}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div style={{ marginTop: 24 }}>
                        <Button
                          style={backButtonStyle}
                          onClick={current > 0 ? prev : () => navigate("/solicitudes")}
                        >
                          {current > 0 ? "Regresar" : "Cancelar"}
                        </Button>

                        {current < steps.length - 1 ? (
                          <Button className={"cancel-button"} onClick={next}>
                            Continuar
                          </Button>
                        ) : (
                          <Button className={"send-button"} onClick={() => saveData()}>
                            Enviar
                          </Button>
                        )}
                      </div>
                      {current > 0 && (
                        <div style={{ marginTop: 16 }}>
                          <a
                            href="/solicitudes"
                            style={{
                              color: "#C8C8C8",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                          >
                            <p className={"label"}>Quiero cancelar mi solicitud</p>
                          </a>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
